import { inject, Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { TranslateService } from '@ngx-translate/core';
import { SubMenu } from '@shared/model/menu-item.type';
import { ObjectUtils } from '@shared/utils/object.utils';

@Injectable({ providedIn: 'root' })
export class ConfigurationMenuService {
  private readonly translateService = inject(TranslateService);

  getMenu(): SubMenu {
    const items = [
      { label: 'sub-menu-configuration.account', routerLink: AppRoutes.Configuration.root },
      { label: 'sub-menu-configuration.auto-submission', routerLink: AppRoutes.Configuration.AutoSubmission },
      { label: 'menu.alert', routerLink: AppRoutes.Configuration.Alert },
      { label: 'menu.maileva', routerLink: AppRoutes.Configuration.Maileva },
      { label: 'menu.asterion', routerLink: AppRoutes.Configuration.Asterion },
      { label: 'menu.retour_mod', routerLink: AppRoutes.Configuration.RetourMod },
      { label: 'menu.relay_mod', routerLink: AppRoutes.Configuration.RelayMod },
      { label: 'menu.relay_thetys', routerLink: AppRoutes.Configuration.RelayThetys },
      { label: 'menu.thetys_chorus', routerLink: AppRoutes.Configuration.ThetysChorus },
      { label: 'menu.email', routerLink: AppRoutes.Configuration.Email },
      { label: 'sub-menu-configuration.archivag-simple', routerLink: AppRoutes.Configuration.ArchivageSimple },
      { label: 'sub-menu-configuration.archivag-legal', routerLink: AppRoutes.Configuration.ArchivageLegal },
      { label: 'menu.chorus', routerLink: AppRoutes.Configuration.Chorus },
      { label: 'sub-menu-configuration.print', routerLink: AppRoutes.Configuration.Print },
      { label: 'sub-menu-configuration.settings', routerLink: AppRoutes.Configuration.ConfSearch },
      { label: 'sub-menu-configuration.search-status', routerLink: AppRoutes.Configuration.ConfSearchStatus },
      { label: 'sub-menu-configuration.report', routerLink: AppRoutes.Configuration.Report },
      { label: 'sub-menu-configuration.validator', routerLink: AppRoutes.Configuration.Validator },
      { label: 'sub-menu-configuration.signed-pdf', routerLink: AppRoutes.Configuration.SignedPdf },
      { label: 'sub-menu-configuration.signature', routerLink: AppRoutes.Configuration.Signature },
      { label: 'menu.pres', routerLink: AppRoutes.Configuration.Pres },
      { label: 'menu.sms', routerLink: AppRoutes.Configuration.Sms },
      { label: 'menu.ar24', routerLink: AppRoutes.Configuration.Ar24 },
      { label: 'menu.coffre_opto', routerLink: AppRoutes.Configuration.CoffreOpto },
      { label: 'menu.pres_chorus', routerLink: AppRoutes.Configuration.PresChorus },
      { label: 'menu.tessi', routerLink: AppRoutes.Configuration.Tessi },
      { label: 'menu.base_de_donnees', routerLink: AppRoutes.Configuration.GestionBaseDonnees },
      { label: 'menu.generix', routerLink: AppRoutes.Configuration.Generix },
      { label: 'menu.onboarding', routerLink: AppRoutes.Configuration.Onboarding },
      { label: 'menu.fileWizard', routerLink: AppRoutes.Configuration.FileWizard },
      { label: 'menu.imprimeur', routerLink: AppRoutes.Configuration.Imprimeur },
      { label: 'menu.uploadAPI', routerLink: AppRoutes.Configuration.UploadAPI },
      { label: 'menu.sdl', routerLink: AppRoutes.Configuration.Sdl },
      { label: 'menu.jupiter', routerLink: AppRoutes.Configuration.Jupiter },
      { label: 'menu.api', routerLink: AppRoutes.Configuration.Api },
      { label: 'menu.coffreo', routerLink: AppRoutes.Configuration.Coffreo },
      { label: 'sub-menu-configuration.virtual-printer', routerLink: AppRoutes.Configuration.VirtualPrinter },
      { label: 'sub-menu-configuration.corus', routerLink: AppRoutes.Configuration.Corus },
      { label: 'sub-menu-configuration.paragon', routerLink: AppRoutes.Configuration.Paragon },
      { label: 'menu.extraction-pnd', routerLink: AppRoutes.Configuration.ExtractionPnd },
      { label: 'sub-menu-configuration.pdf-send-name', routerLink: AppRoutes.Configuration.PdfSendName },
      { label: 'sub-menu-configuration.pdf-output-name', routerLink: AppRoutes.Configuration.PdfOutputName },
      { label: 'sub-menu-configuration.duplicate-management', routerLink: AppRoutes.Configuration.DuplicateManagement },
    ].sort((a, b) =>
      ObjectUtils.sortStringFn(this.translateService.instant(a.label), this.translateService.instant(b.label)),
    );
    return {
      root: { label: 'main-menu.configuration', routerLink: AppRoutes.Configuration.root },
      items,
    };
  }
}
